module.exports = __webpack_public_path__ + "img/supersport-united-logo-icon.902065af.png";